import { useTranslation } from 'hooks';
import { FC } from 'react';
import Button from 'shared/ui/button/button';
import { Modal } from 'shared/ui/modal/modal';
import { ModalActions } from 'shared/ui/modal/modal-actions/modal-actions';
import cls from './resumeSubscriptionModal.module.scss';

interface ResumeModalProps {
  isOpen: boolean;
  nextBillingDate: string;
  amount: string;
  onClose: () => void;
  onClickCancel: () => void;
  onClickResume: () => void;
}

export const ResumeModal: FC<ResumeModalProps> = ({
  isOpen,
  nextBillingDate,
  amount,
  onClose,
  onClickCancel,
  onClickResume,
}) => {
  const { t } = useTranslation();
  const template = t('resumeSubscriptionDesc');
  const [beforeDate, rest = ''] = template.split('{date}');
  const [betweenDateAndAmount, afterAmount] = rest.split('{amount}');

  return (
    <Modal width={450} isOpen={isOpen} onClose={onClose} className={cls.modal}>
      <h3>{t('resumeSubscriptionHeading')}</h3>
      <p>
        {beforeDate}
        <b>{nextBillingDate}</b>
        {betweenDateAndAmount}
        <b>{amount}</b>
        {afterAmount}
      </p>
      <ModalActions>
        <Button theme='text' tone='default' onClick={onClickCancel}>
          {t('cancel')}
        </Button>
        <Button theme='filled' tone='default' onClick={onClickResume}>
          {t('confirmResume')}
        </Button>
      </ModalActions>
    </Modal>
  );
};
